/* eslint-disable object-curly-newline, object-curly-spacing */
<template>
	<!--startingPoint = 0, flyer = 1, socialbanner = 2, email =3, video = 4, ppt = 5, pricing flyer = 6-->
	<nav
		v-if="selectedMediaType === null"
		aria-label="Brand Builder"
		class="brand-builder-tools"
	>
		<BrandBuilderTool
			v-for="(tool, index) in mediaTypes[0].steps"
			:key="index"
			:icon="tool.icon"
			:icon-weight="tool.iconWeight"
			:name="tool.name"
			:route="tool.route"
			:allowDisable="true"
			:currentCampaignId="currentCampaign"
		/>
	</nav>
	<nav
		v-else-if="selectedMediaType === MEDIA_ID.PRICING_FLYER"
		aria-label="Brand Builder"
		class="brand-builder-tools"
	>
		<!--Keeps the tabs for the Pricing Flyer "active" -->
		<BrandBuilderTool
			v-for="(tool, index) in mediaTypes[selectedMediaType].steps"
			:key="index"
			:icon="tool.icon"
			:icon-weight="tool.iconWeight"
			:name="tool.name"
			:route="tool.route"
			:allowDisable="false"
			:currentCampaignId="currentCampaign"
			:class="'bb-tool-' + tool.route"
		/>
	</nav>
	<nav v-else aria-label="Brand Builder" class="brand-builder-tools">
		<!--All other bb tools -->
		<BrandBuilderTool
			v-for="(tool, index) in mediaTypes[selectedMediaType].steps"
			:key="index"
			:icon="tool.icon"
			:icon-weight="tool.iconWeight"
			:name="tool.name"
			:route="tool.route"
			:allowDisable="true"
			:currentCampaignId="currentCampaign"
			:class="'bb-tool-' + tool.route"
		/>
	</nav>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import BrandBuilderTool from '@/components/brand-builder/BrandBuilderTool.vue';
import { MEDIA_ID } from '@/constants/brand-builder';

export default {
	name: 'BrandBuilderToolbar',
	components: {
		BrandBuilderTool,
	},
	data() {
		return {
			MEDIA_ID,
			mediaTypes: [
				{
					item: 'startingPoint',
					steps: [
						{
							icon: 'photo-video',
							iconWeight: 'fal',
							name: 'Media',
							route: 'media',
						},
						{
							icon: 'font',
							iconWeight: 'fal',
							name: 'Text',
							route: 'text',
						},
						{
							icon: 'pencil-ruler',
							iconWeight: 'fal',
							name: 'Layout',
							route: 'design',
						},
					],
				},
				{
					item: 'flyer',
					steps: [
						{
							icon: 'photo-video',
							iconWeight: 'fal',
							name: 'Media',
							route: 'media',
						},
						{
							icon: 'font',
							iconWeight: 'fal',
							name: 'Text',
							route: 'text',
						},
						{
							icon: 'pencil-ruler',
							iconWeight: 'fal',
							name: 'Layout',
							route: 'design',
						},
						{
							icon: 'camera-retro',
							iconWeight: 'fal',
							name: 'Images',
							route: 'images',
						},
						{
							icon: 'palette',
							iconWeight: 'fal',
							name: 'Colors',
							route: 'colors',
						},
						{
							icon: 'address-card',
							iconWeight: 'fal',
							name: 'Branding',
							route: 'branding',
						},
						{
							icon: 'balance-scale',
							iconWeight: 'fal',
							name: 'Legal',
							route: 'legal',
						},
						{
							icon: 'eye',
							iconWeight: 'fal',
							name: 'Preview',
							route: 'sm-preview',
						},
						{
							icon: 'cloud-download',
							iconWeight: 'fal',
							name: 'Export',
							route: 'export',
						},
					],
				},
				{
					item: 'social',
					steps: [
						{
							icon: 'photo-video',
							iconWeight: 'fal',
							name: 'Media',
							route: 'media',
						},
						{
							icon: 'font',
							iconWeight: 'fal',
							name: 'Text',
							route: 'text',
						},
						{
							icon: 'pencil-ruler',
							iconWeight: 'fal',
							name: 'Layout',
							route: 'design',
						},
						{
							icon: 'camera-retro',
							iconWeight: 'fal',
							name: 'Images',
							route: 'images',
						},
						{
							icon: 'palette',
							iconWeight: 'fal',
							name: 'Colors',
							route: 'colors',
						},
						{
							icon: 'eye',
							iconWeight: 'fal',
							name: 'Preview',
							route: 'sm-preview',
						},
						{
							icon: 'cloud-download',
							iconWeight: 'fal',
							name: 'Export',
							route: 'export',
						},
					],
				},
				{
					item: 'email',
					steps: [
						{
							icon: 'photo-video',
							iconWeight: 'fal',
							name: 'Media',
							route: 'media',
						},
						{
							icon: 'font',
							iconWeight: 'fal',
							name: 'Text',
							route: 'text',
						},
						{
							icon: 'pencil-ruler',
							iconWeight: 'fal',
							name: 'Layout',
							route: 'design',
						},
						{
							icon: 'camera-retro',
							iconWeight: 'fal',
							name: 'Images',
							route: 'images',
						},
						{
							icon: 'palette',
							iconWeight: 'fal',
							name: 'Colors',
							route: 'colors',
						},
						{
							icon: 'address-card',
							iconWeight: 'fal',
							name: 'Branding',
							route: 'branding',
						},
						{
							icon: 'balance-scale',
							iconWeight: 'fal',
							name: 'Legal',
							route: 'legal',
						},
						{
							icon: 'eye',
							iconWeight: 'fal',
							name: 'Preview',
							route: 'sm-preview',
						},
						{
							icon: 'paper-plane',
							iconWeight: 'fal',
							name: 'Send',
							route: 'export',
						},
					],
				},
				{
					item: 'video',
					steps: [
						{
							icon: 'photo-video',
							iconWeight: 'fal',
							name: 'Media',
							route: 'media',
						},
						{
							icon: 'film-alt',
							iconWeight: 'fal',
							name: 'Videos',
							route: 'design',
						},
						{
							icon: 'address-card',
							iconWeight: 'fal',
							name: 'Branding',
							route: 'branding',
						},
						{
							icon: 'balance-scale',
							iconWeight: 'fal',
							name: 'Legal',
							route: 'legal',
						},
						{
							icon: 'eye',
							iconWeight: 'fal',
							name: 'Preview',
							route: 'preview',
						},
						{
							icon: 'cloud-download',
							iconWeight: 'fal',
							name: 'Export',
							route: 'video-export',
						},
					],
				},
				{
					item: 'ppt',
					steps: [
						{
							icon: 'photo-video',
							iconWeight: 'fal',
							name: 'Media',
							route: 'media',
						},
						{
							icon: 'pencil-ruler',
							iconWeight: 'fal',
							name: 'Layout',
							route: 'design',
						},
						{
							icon: 'cloud-download',
							iconWeight: 'fal',
							name: 'Export',
							route: 'ppt-export',
						},
					],
				},
				{
					item: 'pricing',
					steps: [
						{
							icon: 'usd-circle',
							iconWeight: 'fal',
							name: 'Pricing',
							route: 'pricing',
						},
						{
							icon: 'camera-retro',
							iconWeight: 'fal',
							name: 'Images',
							route: 'upload-images',
						},
						{
							icon: 'palette',
							iconWeight: 'fal',
							name: 'Colors',
							route: 'colors',
						},
						{
							icon: 'font',
							iconWeight: 'fal',
							name: 'Text',
							route: 'text',
						},
						{
							icon: 'address-card',
							iconWeight: 'fal',
							name: 'Branding',
							route: 'branding',
						},
						{
							icon: 'balance-scale',
							iconWeight: 'fal',
							name: 'Legal',
							route: 'legal',
						},
						{
							icon: 'eye',
							iconWeight: 'fal',
							name: 'Preview',
							route: 'sm-preview',
						},
						{
							icon: 'cloud-download',
							iconWeight: 'fal',
							name: 'Export',
							route: 'export',
						},
					],
				},
			],
		};
	},
	props: {
		itemType: String,
		currentCampaign: String,
		item: Object,
		steps: Array,
	},
	computed: mapState({
		expandedMenu: (state) => state.menus.expandedMenu,
		selectedMediaType: (state) => state.brandBuilderEditor.selectedMediaType,
	}),
	methods: mapActions(['toggleExpandedMenu']),
	mounted() {},
};
</script>

<style scoped lang="scss">
.brand-builder-tools {
	top: $top-nav-height + $border-width;
	left: 0;
	z-index: 2;
	position: fixed;
	height: calc(100vh - (#{$top-nav-height} + 1px));
	background-color: $white;
	box-shadow: inset -$b360-border-width-thin $b360-border-width-thin 0 0 $border-color-light;
	width: $brand-builder-width;
	-ms-overflow-style: none;
	overflow-y: auto;
	overflow-x: hidden;
	scroll-snap-type: y mandatory;
	transition: all $b360-motion-duration--longest $b360-motion-easing--accelerate;

	&::-webkit-scrollbar {
		@include rem(width, 10px);
		@media (hover: none) and (pointer: coarse) {
			width: 0;
		}
	}
	&::-webkit-scrollbar-thumb {
		background: $brand-teal;
	}

	&:hover:not(.modal-open) {
		@include rem(scrollbar-width, 10px);
		scrollbar-color: $brand-teal;

		&::-webkit-scrollbar-thumb {
			background: $brand-teal;
		}
	}

	@include sm {
		position: absolute;
		display: flex;
		flex-direction: row;
		top: unset;
		bottom: 0;
		left: 0;
		right: 0;
		z-index: 2;
		height: 90px;
		width: 100%;
		overflow-y: hidden;
		overflow-x: auto;
		scroll-snap-type: x mandatory;
		box-shadow: inset 0px $b360-border-width-thin 0px 0px $border-color-light;
	}

	.bb-tool-sm-preview {
		@include lg {
			display: none;
		}
	}
}
</style>
